import { Text } from "@/components/Text";
import { Card } from "@/components/ui";
import { DOCS, RISE_GITHUB, RISE_TESTNET_EXPLORER } from "@/lib/url";
import { CodeIcon, ExternalLinkIcon, FileTextIcon } from "lucide-react";
import Link from "next/link";

export function Resources() {
  return (
    <Card>
      <Text variant="heading">Resources</Text>
      <div className="space-y-3 grid">
        <Link
          href={RISE_TESTNET_EXPLORER}
          target="_blank"
          className="flex gap-2 hover:underline hover:text-text-accent"
        >
          <ExternalLinkIcon />
          <span className="hover:text-text-accent">Rise Testnet Explorer</span>
        </Link>

        <Link
          href={DOCS}
          target="_blank"
          className="flex gap-2 hover:underline hover:text-text-accent"
        >
          <FileTextIcon />
          <span className="hover:text-text-accent">Documentation</span>
        </Link>

        <Link
          href={RISE_GITHUB}
          target="_blank"
          className="flex gap-2 hover:underline hover:text-text-accent"
        >
          <CodeIcon />
          <span className="hover:text-text-accent">Github</span>
        </Link>
      </div>
    </Card>
  );
}
